let css = require('./action-panel.css');
let { cut } = require('../../../../../../helpers/utils');
const signals = require('../../../../../../signals/bitrix');
const bitrix = require('../../../../../../signals/bitrix');

class PrgoressBar {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.$context.signal(bitrix.resize);
        return {
            click: {
                [cut(css.exportButton)]: this.exportButton,
                [cut(css.backButton)]: this.backButton
            }
        };
    }

    exportButton () {
        this.$context.signal(signals.exportLeadsUsingMapping);
    }

    backButton () {
        this.$context.signal(signals.backToOrderPage);
    }
}

module.exports = {
    constructor: PrgoressBar
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/bitrix-export-leads/action-panel/index.js